import { useParams } from "react-router-dom";

import { useThemeContext } from "../../../context/ThemeContext";
import { content } from "../../../data/content";
import { projectData } from "../../../data/projectData";

import { Card } from "../Card";
import { CardLabel } from "../CardLabel";

import styles from "./StackCard.module.scss";

import type { StackCardProps } from "../types";

export function StackCard({
  variant,
  label,
  labelType,
  stack,
}: StackCardProps) {
  const theme = useThemeContext();
  const { key } = useParams<{ key: string }>();
  const c = content;
  const project = projectData;
  const idx = project.projects.findIndex((p) => p.key === key);
  const p = project.projects[idx] ?? project.projects[0];

  const stackChips = c.stack.map((chip) => ({
    label: chip.replace(/\s*\*/, ""),
    inProgress: chip.includes("*"),
  }));

  const chips =
    variant === "own" && stack ? stack : variant === "project" ? p.stack : [];

  return (
    <Card theme={theme}>
      <CardLabel cardLabelType={labelType} cardLabelText={label ?? ""} />
      <div className={styles.chips}>
        {variant === "own" || variant === "project"
          ? chips.map((chip, i) => (
              <span
                key={i}
                className={styles.chip}
                style={{
                  border: `1px solid ${theme.rule}`,
                  color: theme.muted,
                  background: "transparent",
                }}
              >
                {chip}
              </span>
            ))
          : stackChips.map((chip, i) => (
              <span
                key={i}
                className={styles.chip}
                style={{
                  border: `1px solid ${theme.rule}`,
                  color: chip.inProgress ? theme.acc : theme.muted,
                  background: chip.inProgress
                    ? `${theme.acc}14`
                    : "transparent",
                }}
              >
                {chip.label}
              </span>
            ))}
      </div>
    </Card>
  );
}
